import React from "react";
import { Link } from "react-router-dom";
import { Mail, Rocket, MapPin } from "lucide-react";
import { trackEvent } from "@/lib/retention";

/**
 * Non-invasive recovery chip-row. Appears below the hero. NO popups, NO
 * modals — pure in-page affordances for visitors hesitating to commit.
 */
const CHIPS = [
  {
    key: "list",
    to: "/contact?intent=list",
    icon: Mail,
    label: "Not ready? Join the Lifted list.",
    event: "list_interest",
  },
  {
    key: "earn",
    to: "/affiliate-zone",
    icon: Rocket,
    label: "Want to earn with the brand?",
    event: "affiliate_cta_click",
  },
  {
    key: "delivery",
    to: "/supplies",
    icon: MapPin,
    label: "Check delivery availability.",
    event: "supplies_cta_click",
  },
];

export default function HesitationRecovery() {
  return (
    <div
      data-testid="hesitation-recovery"
      className="flex flex-wrap gap-2 mt-6"
    >
      {CHIPS.map((c) => (
        <Link
          key={c.key}
          to={c.to}
          onClick={() => trackEvent(c.event, { surface: "hesitation_recovery" })}
          data-testid={`hesitation-recovery-${c.key}`}
          className="inline-flex items-center gap-2 chip chip--ghost hover:text-lifted-green transition-colors"
        >
          <c.icon className="h-3 w-3" aria-hidden="true" />
          <span>{c.label}</span>
        </Link>
      ))}
    </div>
  );
}
